// Arrow-key movement for the desktop nav (WAI-ARIA disclosure navigation).
// Left/Right move between top-level items, Down enters a title's link
// column, Up/Down move within it (Up from the first link returns to the
// title), and Home/End jump to the first/last item at the current level.

type NavFocus =
    | { kind: "top"; index: number }
    | { kind: "link"; index: number };

export const navKeyTarget = (
    key: string,
    position: {
        topIndex: number;
        topCount: number;
        // -1 when focus is on the top-level item itself.
        linkIndex: number;
        linkCount: number;
    },
): NavFocus | null => {
    const { topIndex, topCount, linkIndex, linkCount } = position;
    const top = (index: number): NavFocus => ({
        kind: "top",
        index: (index + topCount) % topCount,
    });
    const link = (index: number): NavFocus => ({ kind: "link", index });

    switch (key) {
        case "ArrowRight":
            return top(topIndex + 1);
        case "ArrowLeft":
            return top(topIndex - 1);
    }

    if (linkIndex === -1) {
        switch (key) {
            case "ArrowDown":
                return linkCount > 0 ? link(0) : null;
            case "Home":
                return top(0);
            case "End":
                return top(topCount - 1);
        }
        return null;
    }

    switch (key) {
        case "ArrowDown":
            return linkIndex + 1 < linkCount ? link(linkIndex + 1) : null;
        case "ArrowUp":
            return linkIndex === 0 ? top(topIndex) : link(linkIndex - 1);
        case "Home":
            return link(0);
        case "End":
            return link(linkCount - 1);
    }
    return null;
};
